<template lang="pug">
  div.wrap-item-slide-uploader
    div(v-if="!images").uploader.cursor-pointer
      input(ref="inputFile"
        type="file" accept="application/pdf"
        v-on:change="onFileChange").input-file
      div(@click="onDragArea"
        @dragenter="dragEnter"
        @dragleave="dragLeave" 
        @dragover.prevent
        @drop.prevent="dropFile"
        :class="{'is-enter': isEnter}").drag-area.f.fh
        div(v-if="!isLoading").slide-uploader-content
          div.f.fc.mb6
            v-icon(:color="(isEnter) ? pallete.$active_color : '#fff'"
              size="120px") mdi-file-upload-outline
          span.text-center.fz16.block.bold Upload slide data
          span.text-center.fz14.block (PDF only)
        div(v-else)
          v-progress-circular(indeterminate)
    div(v-else).wrap-image-preview
      div.f.fm.flex-between.mb8
        a(@click="images = null").btn-select-new-pdf.fz14.block Select new PDF
        div(v-if="isUploading").f.fm
          v-progress-circular(indeterminate size="14" width="2").mr8
          span.fz14 {{`Uploading... (${images.length}/${base64Arr.length})`}}
        div(v-else)
          span.fz14 Upload completed!
      div(v-for="src in images").wrap-img.mb4
        v-img(:src="src")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-item-slide-uploader {
  .uploader {
    position: relative;
    width: 100%;
    height: 420px;
    .input-file {
      visibility: hidden;
      position: absolute;
    }
    .drag-area {
      width: 100%;
      height: 100%;
      border-radius: 9px;
      border: dashed 2px $primary_text_color;
      transition: border 200ms linear;
      &.is-enter {
        border: dashed 2px $active_color;
        span {
          color: $active_color;
        }
      }
      .slide-uploader-content {
        pointer-events: none;
      }
    }
  }
  .wrap-image-preview {
    .btn-select-new-pdf {
      color: $active_color;
    }
  }
}
</style>

<script>
import { storage } from '@/components/utils/firebase'
import Pdf2Image from '@/plugins/pdf2image'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')

export default {
  props: {
    // data: {
    //   type: Object,
    //   required: true
    // }
  },
  data () {
    return {
      files: null,
      images: null,
      base64Arr: [],
      isEnter: false,
      isLoading: false,
      isUploading: false
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  methods: {
    onFileChange (e) {
      this.files = e.target.files || e.dataTransfer.files
      if (!this.files[0]) return
      console.log('onFileChange:', this.files)
      this.uploadFile()
    },
    onDragArea () {
      const inputFile = this.$refs.inputFile
      inputFile.click()
    },
    dragEnter (e) {
      this.isEnter = true
    },
    dragLeave (e) {
      this.isEnter = false
    },
    dropFile (e) {
      this.isEnter = false
      this.files = e.dataTransfer.files
      if (!this.files[0]) return

      if (!this.files[0].type.includes('pdf')
      && !this.files[0].type.includes('PDF')) {
        alert('Please upload pdf file')
        return
      }

      this.uploadFile()
    },
    async uploadFile () {
      this.isLoading = true
      try {
        const file = this.files[0]
        const url = URL.createObjectURL(file)

        // convert img to pdf
        const pdf2image = await Pdf2Image.open(url)
        // const images = await pdf2image.getAllImageDataUrl({scale:2.0})
        const images = await pdf2image.getAllImageDataUrl({ width: 1000, height: 1000 })
        // this.images = images
        // this.uploadImage()

        this.base64Arr = images.map((img, index) => { 
          return {base64: img, index}
        })
        console.log('base64Arr:', this.base64Arr)

        const self = this
        this.isUploading = true
        this.images = []
        let promises = []
        const storageRef = storage.ref()
        for (let i=0; i < this.base64Arr.length; i++) {
          const uniqueStr = this.getUniqueStr()
          this.base64Arr[i].id = uniqueStr
          const imgRef = storageRef.child(`USER/${this.uid}/SLIDE/${uniqueStr}`)
          // const uploadedURL = await imgRef.putString(this.base64Arr[i].base64.split(',')[1], 'base64', { contentType:'image/jpg' })
          //   .then(async (snapshot) => {
          //     const url = await snapshot.ref.getDownloadURL()
          //       .then(async (url) => {
          //         return url
          //       })
          //     console.log('url:', url)
          //     return url
          //   })
          // this.images.push(uploadedURL)

          const p = imgRef.putString(this.base64Arr[i].base64.split(',')[1], 'base64', { contentType:'image/jpg' })
            .then(async (snapshot) => {
              const url = await snapshot.ref.getDownloadURL()
                .then(async (url) => {
                  return url
                })
              console.log('url:', url)
              self.base64Arr[i].uploadedURL = url
              self.images = self.base64Arr
                .filter(e => e.uploadedURL).map(e => e.uploadedURL)
              console.log('self.images:', self.images)
              return url
            })
          promises.push(p)
        } // for

        await Promise.all(promises).then(results => { 
          console.log('results:', results)
        }).catch(reject => { 
          console.log('reject:', reject)
        })

        this.isUploading = false
      } catch (error) {
        console.log(error)
      }
      this.isLoading = false
    },
    getUniqueStr (myStrong){
      let strong = 1000
      if (myStrong) strong = myStrong
      return new Date().getTime().toString(16)  + Math.floor(strong*Math.random()).toString(16)
    }
  }
}
</script>
